import AuditFindingsTable from './AuditFindingsTable';

export default AuditFindingsTable;
